import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer } from '@angular/core';

import { AlertService } from '../../alert';

@Component({
  selector: 'app-shelves',
  templateUrl: './shelves.component.html',
  styleUrls: ['./shelves.component.css']
})
export class ShelvesComponent implements OnInit {

  model: any = {};

  @Input("shelves") shelves: Array<any>;
  @Input("summe") summe: number;
  @Output("onDelete") delete = new EventEmitter<any>();
  @Output("onAdd") add = new EventEmitter<any>();
  @Output("onRelocate") relocate = new EventEmitter<any>();

  constructor(
    private alertService: AlertService
  ) { }

  ngOnInit() {
  }

  deleteShelf(shelf) {
    this.delete.emit(shelf);
  }

  updateItems(items: number, remark: string, shelf: string) {
    this.model.items = items;
    this.model.remark = remark;
    this.model.shelf = shelf;
    this.add.emit(this.model);
  }
  relocateItems(items: number, shelf: string, newshelf: string, remark: string){
    this.model.items = -1*items;
    this.model.shelf = shelf;
    this.model.newshelf = newshelf;
    this.model.remark = remark;
    this.relocate.emit(this.model);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/shared/shelves/shelves.component.ts